// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
  Count,
  CountFromJSON,
  CountToJSON,
  DefaultResponseError,
  DefaultResponseErrorFromJSON,
  DefaultResponseErrorToJSON,
  ForbiddenError,
  ForbiddenErrorFromJSON,
  ForbiddenErrorToJSON,
  Webhook,
  WebhookFromJSON,
  WebhookToJSON,
  WebhookCopyPayload,
  WebhookCopyPayloadFromJSON,
  WebhookCopyPayloadToJSON,
  WebhookDeleteResult,
  WebhookDeleteResultFromJSON,
  WebhookDeleteResultToJSON,
  WebhookDelivery,
  WebhookDeliveryFromJSON,
  WebhookDeliveryToJSON,
  WebhookDeliveryQueued,
  WebhookDeliveryQueuedFromJSON,
  WebhookDeliveryQueuedToJSON,
  WebhookDeliveryState,
  WebhookDeliveryStateFromJSON,
  WebhookDeliveryStateToJSON,
  WebhookEvent,
  WebhookEventFromJSON,
  WebhookEventToJSON,
  WebhookEventType,
  WebhookEventTypeFromJSON,
  WebhookEventTypeToJSON,
  WebhookEventTypeInfo,
  WebhookEventTypeInfoFromJSON,
  WebhookEventTypeInfoToJSON,
  WebhookResourceType,
  WebhookResourceTypeFromJSON,
  WebhookResourceTypeToJSON,
  WebhookSecret,
  WebhookSecretFromJSON,
  WebhookSecretToJSON,
  WebhookSecretPayload,
  WebhookSecretPayloadFromJSON,
  WebhookSecretPayloadToJSON,
} from "../models";

export interface AddWebhookRequest {
  webhook: Webhook;
  project: number;
}

export interface ChangeWebhookSecretRequest {
  webhookSecretPayload: WebhookSecretPayload;
  project: number;
}

export interface CopyWebhooksRequest {
  webhookCopyPayload: WebhookCopyPayload;
  project: number;
}

export interface CountWebhookDeliveriesRequest {
  project: number;
  webhook?: number;
  event?: number;
  eventType?: WebhookEventType;
  status?: WebhookDeliveryState;
  createdAtGte?: string;
  createdAtLt?: string;
}

export interface CountWebhookEventsRequest {
  project: number;
  eventType?: WebhookEventType;
  resourceType?: WebhookResourceType;
  resourceId?: number;
  occurredAtGte?: string;
  occurredAtLt?: string;
}

export interface CountWebhooksRequest {
  project: number;
  enabled?: boolean;
}

export interface DeleteWebhookRequest {
  project: number;
  id: number;
}

export interface EditWebhookRequest {
  webhook: Webhook;
  project: number;
  id: number;
}

export interface GetWebhookRequest {
  project: number;
  id: number;
}

export interface GetWebhookDeliveriesRequest {
  project: number;
  limit?: number;
  start?: number;
  webhook?: number;
  event?: number;
  eventType?: WebhookEventType;
  status?: WebhookDeliveryState;
  createdAtGte?: string;
  createdAtLt?: string;
}

export interface GetWebhookDeliveryRequest {
  project: number;
  id: number;
}

export interface GetWebhookEventRequest {
  project: number;
  id: number;
}

export interface GetWebhookEventTypesRequest {
  project: number;
}

export interface GetWebhookEventsRequest {
  project: number;
  limit?: number;
  start?: number;
  eventType?: WebhookEventType;
  resourceType?: WebhookResourceType;
  resourceId?: number;
  occurredAtGte?: string;
  occurredAtLt?: string;
}

export interface GetWebhookSecretStatusRequest {
  project: number;
}

export interface GetWebhooksRequest {
  project: number;
  limit?: number;
  start?: number;
  enabled?: boolean;
}

export interface RetryWebhookDeliveryRequest {
  project: number;
  id: number;
}

export interface TestWebhookRequest {
  project: number;
  id: number;
}

/**
 * no description
 */
export class WebhooksApi extends runtime.BaseAPI {
  /**
   * Requires Administrator rank and access to the query project. Every referenced resource must belong to that project. Configuration may be saved while project webhooks are disabled. Delivery uses the one shared project secret; per-endpoint secrets are not accepted.
   * Create a webhook
   */
  async addWebhookRaw(
    requestParameters: AddWebhookRequest
  ): Promise<runtime.ApiResponse<Webhook>> {
    if (
      requestParameters.webhook === null ||
      requestParameters.webhook === undefined
    ) {
      throw new runtime.RequiredError(
        "webhook",
        "Required parameter requestParameters.webhook was null or undefined when calling addWebhook."
      );
    }

    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling addWebhook."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/webhooks`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: WebhookToJSON(requestParameters.webhook),
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      WebhookFromJSON(jsonValue)
    );
  }

  /**
   * Requires Administrator rank and access to the query project. Every referenced resource must belong to that project. Configuration may be saved while project webhooks are disabled. Delivery uses the one shared project secret; per-endpoint secrets are not accepted.
   * Create a webhook
   */
  async addWebhook(requestParameters: AddWebhookRequest): Promise<Webhook> {
    const response = await this.addWebhookRaw(requestParameters);
    return await response.value();
  }

  /**
   * Requires Administrator rank and access to the query project. Every referenced resource must belong to that project. generate is valid only when no shared secret exists. reset requires confirm_reset=true and an existing secret. Return the value once; reset immediately replaces the key for ALL project endpoints, including subsequent retries of pending deliveries. A successful response must include has_secret=true and the new secret value; ordinary GET responses always omit secret. Configuration and secret management remain available while deliveries are disabled.
   * Generate or reset the shared project webhook secret
   */
  async changeWebhookSecretRaw(
    requestParameters: ChangeWebhookSecretRequest
  ): Promise<runtime.ApiResponse<WebhookSecret>> {
    if (
      requestParameters.webhookSecretPayload === null ||
      requestParameters.webhookSecretPayload === undefined
    ) {
      throw new runtime.RequiredError(
        "webhookSecretPayload",
        "Required parameter requestParameters.webhookSecretPayload was null or undefined when calling changeWebhookSecret."
      );
    }

    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling changeWebhookSecret."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/webhooksecrets`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: WebhookSecretPayloadToJSON(requestParameters.webhookSecretPayload),
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      WebhookSecretFromJSON(jsonValue)
    );
  }

  /**
   * Requires Administrator rank and access to the query project. Every referenced resource must belong to that project. generate is valid only when no shared secret exists. reset requires confirm_reset=true and an existing secret. Return the value once; reset immediately replaces the key for ALL project endpoints, including subsequent retries of pending deliveries. A successful response must include has_secret=true and the new secret value; ordinary GET responses always omit secret. Configuration and secret management remain available while deliveries are disabled.
   * Generate or reset the shared project webhook secret
   */
  async changeWebhookSecret(
    requestParameters: ChangeWebhookSecretRequest
  ): Promise<WebhookSecret> {
    const response = await this.changeWebhookSecretRaw(requestParameters);
    return await response.value();
  }

  /**
   * Requires Administrator rank and access to the query project (the target). The source project must be another project of the same company with project webhooks enabled. Copies the selected source endpoints with their name, events and enabled state, and applies the optional new url, timeout_seconds and max_attempts of each item. The signing secret, events and delivery history are not copied. All copies are saved in one transaction under the target project's endpoint limit; when any item is invalid, nothing is saved. Like addWebhook, configuration may be saved while the target project's webhooks are disabled.
   * Copy webhooks from another project
   */
  async copyWebhooksRaw(
    requestParameters: CopyWebhooksRequest
  ): Promise<runtime.ApiResponse<Array<Webhook>>> {
    if (
      requestParameters.webhookCopyPayload === null ||
      requestParameters.webhookCopyPayload === undefined
    ) {
      throw new runtime.RequiredError(
        "webhookCopyPayload",
        "Required parameter requestParameters.webhookCopyPayload was null or undefined when calling copyWebhooks."
      );
    }

    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling copyWebhooks."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/webhooks/copy`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: WebhookCopyPayloadToJSON(requestParameters.webhookCopyPayload),
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(WebhookFromJSON)
    );
  }

  /**
   * Requires Administrator rank and access to the query project (the target). The source project must be another project of the same company with project webhooks enabled. Copies the selected source endpoints with their name, events and enabled state, and applies the optional new url, timeout_seconds and max_attempts of each item. The signing secret, events and delivery history are not copied. All copies are saved in one transaction under the target project's endpoint limit; when any item is invalid, nothing is saved. Like addWebhook, configuration may be saved while the target project's webhooks are disabled.
   * Copy webhooks from another project
   */
  async copyWebhooks(
    requestParameters: CopyWebhooksRequest
  ): Promise<Array<Webhook>> {
    const response = await this.copyWebhooksRaw(requestParameters);
    return await response.value();
  }

  /**
   * Requires Administrator rank and access to the query project. Every referenced resource must belong to that project.
   * Count webhook deliveries
   */
  async countWebhookDeliveriesRaw(
    requestParameters: CountWebhookDeliveriesRequest
  ): Promise<runtime.ApiResponse<Count>> {
    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling countWebhookDeliveries."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    if (requestParameters.webhook !== undefined) {
      queryParameters["webhook"] = requestParameters.webhook;
    }

    if (requestParameters.event !== undefined) {
      queryParameters["event"] = requestParameters.event;
    }

    if (requestParameters.eventType !== undefined) {
      queryParameters["event_type"] = requestParameters.eventType;
    }

    if (requestParameters.status !== undefined) {
      queryParameters["status"] = requestParameters.status;
    }

    if (requestParameters.createdAtGte !== undefined) {
      queryParameters["created_at_gte"] = requestParameters.createdAtGte;
    }

    if (requestParameters.createdAtLt !== undefined) {
      queryParameters["created_at_lt"] = requestParameters.createdAtLt;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/webhookdeliveries/count`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CountFromJSON(jsonValue)
    );
  }

  /**
   * Requires Administrator rank and access to the query project. Every referenced resource must belong to that project.
   * Count webhook deliveries
   */
  async countWebhookDeliveries(
    requestParameters: CountWebhookDeliveriesRequest
  ): Promise<Count> {
    const response = await this.countWebhookDeliveriesRaw(requestParameters);
    return await response.value();
  }

  /**
   * Requires Administrator rank and access to the query project. Every referenced resource must belong to that project.
   * Count stored webhook events
   */
  async countWebhookEventsRaw(
    requestParameters: CountWebhookEventsRequest
  ): Promise<runtime.ApiResponse<Count>> {
    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling countWebhookEvents."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    if (requestParameters.eventType !== undefined) {
      queryParameters["event_type"] = requestParameters.eventType;
    }

    if (requestParameters.resourceType !== undefined) {
      queryParameters["resource_type"] = requestParameters.resourceType;
    }

    if (requestParameters.resourceId !== undefined) {
      queryParameters["resource_id"] = requestParameters.resourceId;
    }

    if (requestParameters.occurredAtGte !== undefined) {
      queryParameters["occurred_at_gte"] = requestParameters.occurredAtGte;
    }

    if (requestParameters.occurredAtLt !== undefined) {
      queryParameters["occurred_at_lt"] = requestParameters.occurredAtLt;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/webhookevents/count`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CountFromJSON(jsonValue)
    );
  }

  /**
   * Requires Administrator rank and access to the query project. Every referenced resource must belong to that project.
   * Count stored webhook events
   */
  async countWebhookEvents(
    requestParameters: CountWebhookEventsRequest
  ): Promise<Count> {
    const response = await this.countWebhookEventsRaw(requestParameters);
    return await response.value();
  }

  /**
   * Requires Administrator rank and access to the query project. Every referenced resource must belong to that project.
   * Count project webhooks
   */
  async countWebhooksRaw(
    requestParameters: CountWebhooksRequest
  ): Promise<runtime.ApiResponse<Count>> {
    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling countWebhooks."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    if (requestParameters.enabled !== undefined) {
      queryParameters["enabled"] = requestParameters.enabled;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/webhooks/count`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CountFromJSON(jsonValue)
    );
  }

  /**
   * Requires Administrator rank and access to the query project. Every referenced resource must belong to that project.
   * Count project webhooks
   */
  async countWebhooks(requestParameters: CountWebhooksRequest): Promise<Count> {
    const response = await this.countWebhooksRaw(requestParameters);
    return await response.value();
  }

  /**
   * Requires Administrator rank and access to the query project. Every referenced resource must belong to that project. Prevents new/pending sends and retains event/delivery history for the retention window. Does not delete or rotate the project secret.
   * Delete a webhook
   */
  async deleteWebhookRaw(
    requestParameters: DeleteWebhookRequest
  ): Promise<runtime.ApiResponse<WebhookDeleteResult>> {
    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling deleteWebhook."
      );
    }

    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling deleteWebhook."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/webhooks/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      WebhookDeleteResultFromJSON(jsonValue)
    );
  }

  /**
   * Requires Administrator rank and access to the query project. Every referenced resource must belong to that project. Prevents new/pending sends and retains event/delivery history for the retention window. Does not delete or rotate the project secret.
   * Delete a webhook
   */
  async deleteWebhook(
    requestParameters: DeleteWebhookRequest
  ): Promise<WebhookDeleteResult> {
    const response = await this.deleteWebhookRaw(requestParameters);
    return await response.value();
  }

  /**
   * Requires Administrator rank and access to the query project. Every referenced resource must belong to that project. Replaces editable endpoint configuration. Disabling cancels unsent attempts; requests already sent may finish.
   * Edit a webhook
   */
  async editWebhookRaw(
    requestParameters: EditWebhookRequest
  ): Promise<runtime.ApiResponse<Webhook>> {
    if (
      requestParameters.webhook === null ||
      requestParameters.webhook === undefined
    ) {
      throw new runtime.RequiredError(
        "webhook",
        "Required parameter requestParameters.webhook was null or undefined when calling editWebhook."
      );
    }

    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling editWebhook."
      );
    }

    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling editWebhook."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/webhooks/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: WebhookToJSON(requestParameters.webhook),
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      WebhookFromJSON(jsonValue)
    );
  }

  /**
   * Requires Administrator rank and access to the query project. Every referenced resource must belong to that project. Replaces editable endpoint configuration. Disabling cancels unsent attempts; requests already sent may finish.
   * Edit a webhook
   */
  async editWebhook(requestParameters: EditWebhookRequest): Promise<Webhook> {
    const response = await this.editWebhookRaw(requestParameters);
    return await response.value();
  }

  /**
   * Requires Administrator rank and access to the query project. Every referenced resource must belong to that project.
   * Get a webhook
   */
  async getWebhookRaw(
    requestParameters: GetWebhookRequest
  ): Promise<runtime.ApiResponse<Webhook>> {
    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling getWebhook."
      );
    }

    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling getWebhook."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/webhooks/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      WebhookFromJSON(jsonValue)
    );
  }

  /**
   * Requires Administrator rank and access to the query project. Every referenced resource must belong to that project.
   * Get a webhook
   */
  async getWebhook(requestParameters: GetWebhookRequest): Promise<Webhook> {
    const response = await this.getWebhookRaw(requestParameters);
    return await response.value();
  }

  /**
   * Requires Administrator rank and access to the query project. Every referenced resource must belong to that project. Newest first by id. List summaries omit attempt bodies; fetch details on demand. Attempts/events retained for 30 days.
   * Get webhook delivery logs
   */
  async getWebhookDeliveriesRaw(
    requestParameters: GetWebhookDeliveriesRequest
  ): Promise<runtime.ApiResponse<Array<WebhookDelivery>>> {
    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling getWebhookDeliveries."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    if (requestParameters.limit !== undefined) {
      queryParameters["_limit"] = requestParameters.limit;
    }

    if (requestParameters.start !== undefined) {
      queryParameters["_start"] = requestParameters.start;
    }

    if (requestParameters.webhook !== undefined) {
      queryParameters["webhook"] = requestParameters.webhook;
    }

    if (requestParameters.event !== undefined) {
      queryParameters["event"] = requestParameters.event;
    }

    if (requestParameters.eventType !== undefined) {
      queryParameters["event_type"] = requestParameters.eventType;
    }

    if (requestParameters.status !== undefined) {
      queryParameters["status"] = requestParameters.status;
    }

    if (requestParameters.createdAtGte !== undefined) {
      queryParameters["created_at_gte"] = requestParameters.createdAtGte;
    }

    if (requestParameters.createdAtLt !== undefined) {
      queryParameters["created_at_lt"] = requestParameters.createdAtLt;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/webhookdeliveries`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(WebhookDeliveryFromJSON)
    );
  }

  /**
   * Requires Administrator rank and access to the query project. Every referenced resource must belong to that project. Newest first by id. List summaries omit attempt bodies; fetch details on demand. Attempts/events retained for 30 days.
   * Get webhook delivery logs
   */
  async getWebhookDeliveries(
    requestParameters: GetWebhookDeliveriesRequest
  ): Promise<Array<WebhookDelivery>> {
    const response = await this.getWebhookDeliveriesRaw(requestParameters);
    return await response.value();
  }

  /**
   * Requires Administrator rank and access to the query project. Every referenced resource must belong to that project. Includes bounded/redacted request and response previews, HTTP status, timings and typed errors. Always includes attempts, using an empty array before the first attempt. The shared secret is never included.
   * Get webhook delivery attempts and response
   */
  async getWebhookDeliveryRaw(
    requestParameters: GetWebhookDeliveryRequest
  ): Promise<runtime.ApiResponse<WebhookDelivery>> {
    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling getWebhookDelivery."
      );
    }

    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling getWebhookDelivery."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/webhookdeliveries/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      WebhookDeliveryFromJSON(jsonValue)
    );
  }

  /**
   * Requires Administrator rank and access to the query project. Every referenced resource must belong to that project. Includes bounded/redacted request and response previews, HTTP status, timings and typed errors. Always includes attempts, using an empty array before the first attempt. The shared secret is never included.
   * Get webhook delivery attempts and response
   */
  async getWebhookDelivery(
    requestParameters: GetWebhookDeliveryRequest
  ): Promise<WebhookDelivery> {
    const response = await this.getWebhookDeliveryRaw(requestParameters);
    return await response.value();
  }

  /**
   * Requires Administrator rank and access to the query project. Every referenced resource must belong to that project.
   * Get a stored webhook event
   */
  async getWebhookEventRaw(
    requestParameters: GetWebhookEventRequest
  ): Promise<runtime.ApiResponse<WebhookEvent>> {
    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling getWebhookEvent."
      );
    }

    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling getWebhookEvent."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/webhookevents/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      WebhookEventFromJSON(jsonValue)
    );
  }

  /**
   * Requires Administrator rank and access to the query project. Every referenced resource must belong to that project.
   * Get a stored webhook event
   */
  async getWebhookEvent(
    requestParameters: GetWebhookEventRequest
  ): Promise<WebhookEvent> {
    const response = await this.getWebhookEventRaw(requestParameters);
    return await response.value();
  }

  /**
   * Requires Administrator rank and access to the query project. Every referenced resource must belong to that project. Returns the 14 business types. webhook.test is a diagnostic and is not subscribable.
   * Get supported webhook business event types
   */
  async getWebhookEventTypesRaw(
    requestParameters: GetWebhookEventTypesRequest
  ): Promise<runtime.ApiResponse<Array<WebhookEventTypeInfo>>> {
    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling getWebhookEventTypes."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/webhookeventtypes`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(WebhookEventTypeInfoFromJSON)
    );
  }

  /**
   * Requires Administrator rank and access to the query project. Every referenced resource must belong to that project. Returns the 14 business types. webhook.test is a diagnostic and is not subscribable.
   * Get supported webhook business event types
   */
  async getWebhookEventTypes(
    requestParameters: GetWebhookEventTypesRequest
  ): Promise<Array<WebhookEventTypeInfo>> {
    const response = await this.getWebhookEventTypesRaw(requestParameters);
    return await response.value();
  }

  /**
   * Requires Administrator rank and access to the query project. Every referenced resource must belong to that project. Newest first by id. Project-local immutable event snapshots only; no data from linked records in another project.
   * Get stored webhook events
   */
  async getWebhookEventsRaw(
    requestParameters: GetWebhookEventsRequest
  ): Promise<runtime.ApiResponse<Array<WebhookEvent>>> {
    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling getWebhookEvents."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    if (requestParameters.limit !== undefined) {
      queryParameters["_limit"] = requestParameters.limit;
    }

    if (requestParameters.start !== undefined) {
      queryParameters["_start"] = requestParameters.start;
    }

    if (requestParameters.eventType !== undefined) {
      queryParameters["event_type"] = requestParameters.eventType;
    }

    if (requestParameters.resourceType !== undefined) {
      queryParameters["resource_type"] = requestParameters.resourceType;
    }

    if (requestParameters.resourceId !== undefined) {
      queryParameters["resource_id"] = requestParameters.resourceId;
    }

    if (requestParameters.occurredAtGte !== undefined) {
      queryParameters["occurred_at_gte"] = requestParameters.occurredAtGte;
    }

    if (requestParameters.occurredAtLt !== undefined) {
      queryParameters["occurred_at_lt"] = requestParameters.occurredAtLt;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/webhookevents`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(WebhookEventFromJSON)
    );
  }

  /**
   * Requires Administrator rank and access to the query project. Every referenced resource must belong to that project. Newest first by id. Project-local immutable event snapshots only; no data from linked records in another project.
   * Get stored webhook events
   */
  async getWebhookEvents(
    requestParameters: GetWebhookEventsRequest
  ): Promise<Array<WebhookEvent>> {
    const response = await this.getWebhookEventsRaw(requestParameters);
    return await response.value();
  }

  /**
   * Requires Administrator rank and access to the query project. Every referenced resource must belong to that project. Exactly one secret per project. Returns has_secret=false/version=0 if none exists, and never returns the secret value.
   * Get shared project webhook secret metadata
   */
  async getWebhookSecretStatusRaw(
    requestParameters: GetWebhookSecretStatusRequest
  ): Promise<runtime.ApiResponse<WebhookSecret>> {
    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling getWebhookSecretStatus."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/webhooksecrets`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      WebhookSecretFromJSON(jsonValue)
    );
  }

  /**
   * Requires Administrator rank and access to the query project. Every referenced resource must belong to that project. Exactly one secret per project. Returns has_secret=false/version=0 if none exists, and never returns the secret value.
   * Get shared project webhook secret metadata
   */
  async getWebhookSecretStatus(
    requestParameters: GetWebhookSecretStatusRequest
  ): Promise<WebhookSecret> {
    const response = await this.getWebhookSecretStatusRaw(requestParameters);
    return await response.value();
  }

  /**
   * Requires Administrator rank and access to the query project. Every referenced resource must belong to that project. Returns no secret. Ordered by id descending. Project enable_webhooks remains in the existing projectsettings/AppContext flow.
   * Get project webhooks
   */
  async getWebhooksRaw(
    requestParameters: GetWebhooksRequest
  ): Promise<runtime.ApiResponse<Array<Webhook>>> {
    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling getWebhooks."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    if (requestParameters.limit !== undefined) {
      queryParameters["_limit"] = requestParameters.limit;
    }

    if (requestParameters.start !== undefined) {
      queryParameters["_start"] = requestParameters.start;
    }

    if (requestParameters.enabled !== undefined) {
      queryParameters["enabled"] = requestParameters.enabled;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/webhooks`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(WebhookFromJSON)
    );
  }

  /**
   * Requires Administrator rank and access to the query project. Every referenced resource must belong to that project. Returns no secret. Ordered by id descending. Project enable_webhooks remains in the existing projectsettings/AppContext flow.
   * Get project webhooks
   */
  async getWebhooks(
    requestParameters: GetWebhooksRequest
  ): Promise<Array<Webhook>> {
    const response = await this.getWebhooksRaw(requestParameters);
    return await response.value();
  }

  /**
   * Requires Administrator rank and access to the query project. Every referenced resource must belong to that project. Allowed only for terminal failed deliveries while project/endpoint are enabled and a shared secret exists. Queues a new delivery referencing the SAME event ID/payload. Does not retry a delivered, pending or cancelled delivery. Uses the current shared project secret at send time.
   * Retry a failed webhook delivery
   */
  async retryWebhookDeliveryRaw(
    requestParameters: RetryWebhookDeliveryRequest
  ): Promise<runtime.ApiResponse<WebhookDeliveryQueued>> {
    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling retryWebhookDelivery."
      );
    }

    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling retryWebhookDelivery."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/webhookdeliveries/{id}/retry`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      WebhookDeliveryQueuedFromJSON(jsonValue)
    );
  }

  /**
   * Requires Administrator rank and access to the query project. Every referenced resource must belong to that project. Allowed only for terminal failed deliveries while project/endpoint are enabled and a shared secret exists. Queues a new delivery referencing the SAME event ID/payload. Does not retry a delivered, pending or cancelled delivery. Uses the current shared project secret at send time.
   * Retry a failed webhook delivery
   */
  async retryWebhookDelivery(
    requestParameters: RetryWebhookDeliveryRequest
  ): Promise<WebhookDeliveryQueued> {
    const response = await this.retryWebhookDeliveryRaw(requestParameters);
    return await response.value();
  }

  /**
   * Requires Administrator rank and access to the query project. Every referenced resource must belong to that project. Requires enabled project webhooks, an enabled saved endpoint and an existing shared project secret. Sends synthetic webhook.test data through the real transport, with exactly one attempt. Poll getWebhookDelivery to show response/error.
   * Queue one webhook test POST
   */
  async testWebhookRaw(
    requestParameters: TestWebhookRequest
  ): Promise<runtime.ApiResponse<WebhookDeliveryQueued>> {
    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling testWebhook."
      );
    }

    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling testWebhook."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/webhooks/{id}/test`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      WebhookDeliveryQueuedFromJSON(jsonValue)
    );
  }

  /**
   * Requires Administrator rank and access to the query project. Every referenced resource must belong to that project. Requires enabled project webhooks, an enabled saved endpoint and an existing shared project secret. Sends synthetic webhook.test data through the real transport, with exactly one attempt. Poll getWebhookDelivery to show response/error.
   * Queue one webhook test POST
   */
  async testWebhook(
    requestParameters: TestWebhookRequest
  ): Promise<WebhookDeliveryQueued> {
    const response = await this.testWebhookRaw(requestParameters);
    return await response.value();
  }
}
